<template>
  <transition>
    <div class="feedback z-top fullscreen common-max-width">
      <div class="feedback_nav">
        <div
          class="feedback_nav_back"
          @click="$emit('close-dialog')">
          <img src="../assets/images/nav/back1.png" />
        </div>
        <h4 class="feedback_nav_title">意见反馈</h4>
      </div>
      <div class="feedback_content">
        <div class="feedback_content_title">
          我遇到的问题
        </div>
        <div class="feedback_content_problem">
          <div
            v-for="item in problemList"
            :key="item"
            class="feedback_content_problem_tag"
            :class="{active: form.title === item}"
            @click="tagHandler(item)">
            {{item}}
          </div>
        </div>
        <div class="feedback_content_desc">
          详情描述 （必填）
        </div>
        <textarea
          v-model="form.content"
          class="feedback_content_text">
        </textarea>
        <div
          class="feedback_content_submit"
          @click="feedbackHandler">提交</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getUUID } from '@/utils'
import { sendFeedback } from '@/API/mine'
export default {
  name: 'Feedback',
  props: {
    videoId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      problemList: [
        '无法播放',
        '播放卡顿',
        '标签错误',
        '分类错误',
        '搜索不准',
        '推荐不准',
        '其他'
      ],
      form: {
        device: 2,
        title: '无法播放',
        video_id: 0,
        content: '',
        uuid: getUUID()
      },
      loading: false
    }
  },
  watch: {
    videoId: {
      handler (newValue) {
        this.form.video_id = newValue
      },
      immediate: true
    }
  },
  mounted () {
    document.body.style = 'overflow: hidden;'
  },
  destroyed () {
    document.body.style = ''
  },
  methods: {
    tagHandler (name) {
      this.form.title = name
    },
    async feedbackHandler () {
      if (this.loading) return
      if (!this.form.content) return this.$snackbar({ msg: '详情描述不能为空' })
      if (this.form.content.length < 8 || this.form.content.length > 180) return this.$snackbar({ msg: '详情描述仅能介于 8 ~ 180 个字符' })
      this.loading = true

      try {
        const { msg } = await sendFeedback(this.form)
        this.$snackbar({ msg })
      } catch (err) {
        console.log(err)
      } finally {
        this.$emit('close-dialog')
        this.setTimeout(() => {
          this.loading = false
        }, 500)
      }
    }
  }
}
</script>

<style scoped>
.feedback {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  margin: auto;
  overflow: visible;
  text-align: center;
  background-color: #1d1d1d;
  border-radius: 11px;
}

.feedback_nav {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding: 0 40px;
  font-size: 18px;
  font-weight: 600;
  line-height: 44px;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
}

.feedback_nav_title {
  width: 100%;
  height: 44px;
  padding: 0 0;
  margin: 0 0;
  font-weight: 600;
  line-height: 44px;
  color: rgba(255, 92, 56, 1);
}

.feedback_nav_back {
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 40px;
  height: 44px;
  padding: 5px 10px;
}

.feedback_nav_back img {
  width: 100%;
}

.feedback_content {
  position: absolute;
  top: 44px;
  right: 0;
  bottom: 10px;
  left: 0;
  padding: 25px;
  overflow: auto;
  color: #fff;
}

.feedback_content_title,
.feedback_content_desc {
  margin-bottom: 15px;
  font-size: 20px;
  text-align: left;
}

.feedback_content_problem {
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 40px;
}

.feedback_content_problem_tag {
  box-sizing: border-box;
  flex: 1;
  min-width: 98px;
  max-width: 98px;
  padding: 7px 20px;
  margin: 10px 0 10px 0;
  margin-right: 10px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border: 1px #878789 solid;
  border-radius: 5vw;
}

.feedback_content_problem_tag.active {
  background: rgba(255, 92, 56, 1);
  border-color: rgba(255, 92, 56, 1);
}

.feedback_content_text {
  width: 100%;
  height: 184px;
  font-size: 16px;
  color: #b1b3b6;
  resize: none;
  background: #000;
}

.feedback_content_submit {
  box-sizing: border-box;
  max-width: 500px;
  padding: 10px 20px;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  background: rgba(255, 92, 56, 1);
  border-radius: 5vw;
}

.fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  max-width: 1024px;
  max-height: 100vh;
  overflow: hidden;
  border-radius: 0 !important;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity  0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/feedback.vue